'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdNetworkLocked = function MdNetworkLocked(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 26.6v-2.5c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5v2.5h5z m1.6 0c1 0 1.8 0.8 1.8 1.8v6.6c0 0.9-0.8 1.6-1.8 1.6h-8.2c-1 0-1.8-0.7-1.8-1.6v-6.6c0-1 0.8-1.8 1.8-1.8v-2.5c0-2.2 1.8-4.1 4.1-4.1s4.1 1.9 4.1 4.1v2.5z m-4.1-10c-4.1 0-7.5 3.4-7.5 7.5v0.5c-1 0.9-1.6 2.3-1.6 3.8v5h-21.8l31.8-31.8v15.1c-0.4 0-0.6-0.1-0.9-0.1z' })
        )
    );
};

exports.default = MdNetworkLocked;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/network-locked.js
// module id = 3583
// module chunks = 168707334958949